import {
    Box,
    Heading,
    Text,
    Center,
    Button,
    Divider,
    Flex,
    Link,
} from "@chakra-ui/react";
import * as Analytics from "utils/analytics";

export function QuestionAnswers() {

    return (
        <Box
            maxW={{ base: "300", sm: "450", md: "650", lg: "800" }}
            margin="auto"
        >
            <Center>
                <Divider width="40" mt="12" mb="20" />
            </Center>
            <Center>
                <Heading as="h2" mt={0} mb={16} fontSize="3xl">
                    Questions?
                </Heading>
            </Center>
            {data.map(({ ques, ans, id }) => (
                <Box key={id} mb="16">
                    <Heading as="h3" fontSize="2xl" mb="8">
                        {ques}
                    </Heading>
                    <Text fontSize="lg" fontWeight="400" whiteSpace="pre-wrap">
                        {ans}
                    </Text>
                </Box>
            ))}
        </Box>
    );
}

const data = [
    {
        id: "0",
        ques: "Who are you?",
        ans: `We’re the team behind Tweet Hunter, the X tool that helps you grow and monetize an audience. If you’ve been gathering information about X growth lately, it’s likely you have already come across our product or some of our X growth resources.`,
    },
    {
        id: "1",
        ques: "How qualified are you to give advice about X growth?",
        ans: `Great question. Many people claim they know a lot about building an audience, whether on X or on other platforms, so you’re right to be wary.

What’s great about our team is we’re actually all invested in our own personal X growth. Tom’s at 11K followers, Tibo is nearing 30K followers, Alex is at 26K while JK encompasses us all at over 100K. And we all speak to different audiences: marketers, founders, hustlers, money makers, programmers.

It’s safe to say we know a bit about X growth and have experience across a variety of niches, target audiences and topics. Also, we did create a X growth tool that encompasses a large part of all the things we learned over the years.`,
    },
    {
        id: "2",
        ques: "I want to get more followers on X. What do I do?",
        ans: `If your goal is to grow your X following, you’re in the right place. We suggest you start by taking a look at our “In-depth X Growth” category where you’ll find many articles about growing a X audience. Everything here is free. If you’re looking for something very structured, perhaps consider signing up or purchasing a course from the Courses section. Important: none of these courses are ours and we are not paid to promote them.

But perhaps you already know most of what there is to learn about X growth, and you’re looking for the right tool to do it effortlessly. In that case, let us suggest you give Tweet Hunter a try. It’s free for 7 days and we also offer a 30-day money-back guarantee. So really, there’s no risk at giving it a shot.`,
    },
    {
        id: "3",
        ques: "Is X growth just about followers?",
        ans: `Definitely not. Actually, we tend to say it’s not AT ALL about followers. Followers are more like an intermediate metric or indicator. They’re not the actual goal, even though most people use it as such. For that reason, we do write up a lot of resources about how to grow your X following. But we like to think there’s more to it than just a number.

It’s about follower quality and whether or not you are able to turn those followers into people that drive value for you personally or your business. So yes, followers are great. But even better are email subscribers, users, customers, fans who amplify your content, or simply awesome people who learn from you just as much as you learn from them.`,
    },
    {
        id: "4",
        ques: "I don’t have time to read so much stuff about growing on X. What are the bare essentials?",
        ans: `We get it. We’re all busy and it can be excruciating to spend hours or days or weeks learning about something that boils down to a few essentials. There’s a lot of specifics and nuances to X growth, but for the sake of it let’s just try to make a conservative recap of the basics.

#1 - Define what X growth is to you / your North Star metric (followers, sign ups, subscribers)

#2 - Define your topic of expertise and pick only ONE. Not 2, not 3, ONE.

#3 - Research your topic on X. Who are the experts? What’s working? What are some interesting accounts that don’t have a following? What are they doing wrong?

#4 - Write content in a variety of formats, and block slots in your calendar every week to do it.

#5 - It’s not just about you. Engage meaningfully with other people. Have thoughtful conversations in DMs. Building relationships will help amplify your content in the long run.

#6 - Tools. We’re definitely biased about this one, but if you’re too busy to read up long-form content about X growth, you’re definitely too busy to do all the previous steps without a tool to help you.

Voilà, that’s our 2 cents! It’s definitely not all there is to know, but it’s enough to get started without making important mistakes.`,
    },
];
